class CartTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const triggers = this.querySelectorAll('[data-tab-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const target = trigger.dataset.tabTrigger;
        this.switchTab(target);
      });
    });
  }

  switchTab(targetId) {
    // Toggle active class on triggers
    this.querySelectorAll('[data-tab-trigger]').forEach(t => {
       if (t.dataset.tabTrigger === targetId) {
         t.classList.add('active');
         t.setAttribute('aria-selected', 'true');
       } else {
         t.classList.remove('active');
         t.setAttribute('aria-selected', 'false');
       }
    });
    
    // Toggle visibility of panels
    this.querySelectorAll('[data-tab-panel]').forEach(p => {
       if (p.dataset.tabPanel === targetId) {
         p.style.display = 'block';
         p.setAttribute('aria-hidden', 'false');
       } else {
         p.style.display = 'none';
         p.setAttribute('aria-hidden', 'true');
       }
    });

    // Dispatch event for other components to react
    this.dispatchEvent(new CustomEvent('tab-change', { 
      detail: { tab: targetId },
      bubbles: true 
    }));
  }
}

customElements.define('cart-tabs', CartTabs);
